import { GridProps as VisxGridProps } from '@visx/grid/lib/grids/Grid';
import { Group } from '@visx/group';

import { GridColumns } from '../../../core/components/grid/GridColumns.js';
import { GridRows } from '../../../core/components/grid/GridRows.js';
import {
  getVerticalNumTicks,
  getHorizontalNumTicks,
} from '../../../core/utils/ticks.js';
import type { AnyScale } from '../../types/scales.js';

export type GridProps = VisxGridProps<AnyScale, AnyScale> & {
  'data-testid'?: string;
  highlightZeroLine?: {
    horizontal?: boolean;
    vertical?: boolean;
  };
};
const DEFAULTS = {
  DATA_TEST_ID: 'chart-grid',
  HIGHLIGHT_ZERO_LINE: {
    horizontal: true,
    vertical: true,
  },
};
/**
 * The grid columns component for charts
 */
export function Grid({
  width,
  height,
  xScale,
  yScale,
  highlightZeroLine = DEFAULTS.HIGHLIGHT_ZERO_LINE,
  'data-testid': dataTestId = DEFAULTS.DATA_TEST_ID,
}: GridProps) {
  const numTicksRows = getVerticalNumTicks(height);
  const autoNumTicks = getHorizontalNumTicks(width);

  return (
    <Group data-testid={dataTestId}>
      <GridColumns
        data-testid="chart-grid-columns"
        width={width}
        height={height}
        scale={xScale}
        numTicks={autoNumTicks}
        highlightZeroLine={highlightZeroLine.vertical}
      />
      <GridRows
        data-testid="chart-grid-rows"
        width={width}
        height={height}
        scale={yScale}
        numTicks={numTicksRows}
        highlightZeroLine={highlightZeroLine.horizontal}
      />
    </Group>
  );
}
